import { Armchair } from 'lucide-react';

interface EmptySeatProps {
  waiting?: boolean;
  seatNumber?: number;
}

/** Empty chair on rail — gold ring with seat # inside */
export default function EmptySeat({
  waiting = false,
  seatNumber,
}: EmptySeatProps) {
  return (
    <div
      className={`tp-empty-seat flex flex-col items-center ${waiting ? 'tp-empty-seat-waiting' : ''}`}
      aria-label={seatNumber ? `Seat ${seatNumber} open` : 'Empty seat'}
    >
      <div className="tp-empty-seat-chair flex flex-col items-center justify-center">
        <Armchair size={20} className="tp-empty-seat-chair-icon text-tp-gold" strokeWidth={1.75} />
        {seatNumber != null && (
          <span className="tp-empty-seat-number tabular-nums">{seatNumber}</span>
        )}
      </div>
    </div>
  );
}
